import client from '../client';
import { toInteger } from 'lodash';

export type TApiServiceCharge = {
  id: number;
  volume_band_id: number;
  service_package_id: number;
  charge_in_eur: number;
}

interface ServiceChargeListParams {
  volume_band_id?: number;
  service_package_id?: number;
  service_charge_model_id?: number;
}

const list = (params?: ServiceChargeListParams): Promise<Array<TApiServiceCharge>> =>
  client.get('/service-charge/', { params }).then(response => response.data);

export {
  list
};
